import PrivacyPolicyPage from 'components/Privacy/PrivacyPolicyPage';

function PrivacyPolicy() {
    return (
        <PrivacyPolicyPage />
    ) 
}

export default PrivacyPolicy;